import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell, Divider } from 'sarsaparilla';
import RenderIf from '../utils/JSXUtils';

const Line = PropTypes.shape({
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.number
});

const propTypes = {
  lines: PropTypes.arrayOf(Line).isRequired,
  total: Line
};

export default class CostsTable extends PureComponent {
  constructor(props) {
    super(props);

    this.renderLine = this.renderLine.bind(this);
  }

  renderLine(line) {
    const { title, description, value } = line;
    const cost = `$${(value / 100000).toFixed(2)}`;

    return (
      <Row key={title}>
        <Cell width={8} className="parkpass-costs-table-name">
          <p><strong>{title}</strong></p>
          {RenderIf(description)(<span>{description}</span>)}
        </Cell>
        <Cell width={4} className="parkpass-costs-table-cost">
          <p>{cost}</p>
        </Cell>
      </Row>
    );
  }

  render() {
    const { lines, total } = this.props;

    return (
      <div className="parkpass-costs-table">
        {lines.map(this.renderLine)}
        {RenderIf(total)(
          <div>
            <Divider />
            {this.renderLine(total)}
          </div>
        )}
      </div>
    );
  }
}

CostsTable.propTypes = propTypes;
